/* packages/apps/workoutsmart/src/components/chat/effects/InfoLookupEffectRenderer.jsx */
import React from 'react';
import { Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { alpha } from '@mui/material/styles';

const ActivityRequestEffectRenderer = ({ event }) => {
  return (
    <Chip
      icon={<SearchIcon style={{ fontSize: 16 }} />}
      label="Activity Info"
      size="small"
      variant="outlined"
      sx={{
        borderColor: 'info.main',
        color: 'info.main',
        bgcolor: (theme) => alpha(theme.palette.info.main, 0.05),
        height: 'auto', // Allow expansion
        py: 0.5,        // Add vertical padding for multiline
        '& .MuiChip-label': { 
            whiteSpace: 'normal', // Wrap text
            overflow: 'visible',
            textOverflow: 'clip',
            display: 'block',
        },
        '& .MuiChip-icon': { color: 'inherit' }
      }}
    />
  );
};

export default ActivityRequestEffectRenderer;